export const ApiEndpoints = Object.freeze({
  // Fetch user profile
  createAccount: {
    url: `/auth/create/account`,
    method: "POST",
  },
  sendLoginOTP: {
    url: `/auth/send/login/otp`,
    method: "POST",
  },
  verifyAccount: {
    url: `/auth/verify/account`,
    method: "PUT",
  },
  verifyLoginOTP: {
    url: `/auth/verify/login/otp`,
    method: "POST",
  },
  accessToken: {
    url: `/auth/token/sharepoint`,
    method: "GET",
  },
});
